// extracted by css-extract-rspack-plugin
export default {"MPInput":"MPInput-Plz57j","mpInput":"MPInput-Plz57j"};